import { render, staticRenderFns } from "./questionnaire.vue?vue&type=template&id=4a2b4f7a&scoped=true&"
import script from "./questionnaire.vue?vue&type=script&lang=js&"
export * from "./questionnaire.vue?vue&type=script&lang=js&"
import style0 from "./questionnaire.vue?vue&type=style&index=0&id=4a2b4f7a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2b4f7a",
  null
  
)

component.options.__file = "questionnaire.vue"
export default component.exports